import { NgModule } from '@angular/core';
import { BadRequestHandler } from '@spartacus/core';
import { CustomBadRequestHandler } from './bad-request.handler';

@NgModule({
  providers: [
    {
      provide: BadRequestHandler,
      useExisting: CustomBadRequestHandler,
    },
  ],
})
export class CustomHandlerModule {}
